import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { DryOfferDto } from "@modules/+new/payments/features/fiat-deposit/infrastructure/dto/dry-offer.dto";
import { FeeDetails } from "@modules/+new/payments/shared-payments/entities/fee.model";
import { FinalizationTypes } from "@modules/+new/payments/features/fiat-deposit/domain/entities/finalization-types.enum";
import {
	PaymentProvider,
	PaymentProviderAdapter
} from "@modules/+new/payments/features/fiat-deposit/domain/entities/dry-offer/payment-provider.model";

export interface DryOffer {
	readonly amount: number;
	readonly amountExclFee: number;
	readonly bestVipFeeDifference: number;
	readonly currentFeeAmount: number;
	feeDetails: FeeDetails;
	readonly finalizationType: FinalizationTypes;
	paymentProvider: PaymentProvider;
}

export class DryOfferAdapter extends BaseAdapter<DryOfferDto, DryOffer> {
	public adapt(item: DryOfferDto): DryOffer {
		if (!item) {
			return null;
		}

		return {
			amount: Number(item.amount),
			amountExclFee: Number(item.amount_excl_fee),
			bestVipFeeDifference: Number(item.best_vip_fee_difference),
			currentFeeAmount: Number(item.fee),
			feeDetails: {
				fix: Number(item.fee_fix),
				max: Number(item.fee_max),
				percent: Number(item.fee_percent),
				percentDisplay: Number(item.fee_percent_display)
			},
			finalizationType: <FinalizationTypes>item.finalization_type,
			paymentProvider: new PaymentProviderAdapter().adapt(item.payment_provider)
		};
	}
}
